import { createContext } from "react";

import type { SettingsHeaderOverrideContextValue } from "./types";

export const SettingsHeaderOverrideContext =
  createContext<SettingsHeaderOverrideContextValue | null>(null);
SettingsHeaderOverrideContext.displayName = "SettingsHeaderOverrideContext";
